import React from 'react'

import { styled } from '../../theme'
import { ButtonIcon } from '../Button'
import { CloseIcon } from '../Icons'

const CloseButtonContainer = styled(ButtonIcon)`
  position: absolute;
  right: 8px;
  top: 8px;
`

export const DialogCloseButton = ({ onClick }: { onClick: () => void }) => (
  <CloseButtonContainer onClick={onClick}>
    <CloseIcon />
  </CloseButtonContainer>
)
